import { NgModule } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { GridComponent } from './components/grid/grid.component';
import {
  TuiButtonModule,
  TuiLoaderModule,
  TuiScrollbarModule,
  TuiSvgModule,
  TuiTextfieldControllerModule,
  TUI_SANITIZER, TuiDialogModule
} from '@taiga-ui/core';
import { ColumnsChooserComponent } from './components/grid/columns-chooser/columns-chooser.component';
import { DxScrollViewModule } from 'devextreme-angular';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { NumberInputComponent } from './components/number-input/number-input.component';
import { TextInputComponent } from './components/text-input/text-input.component';
import { TabsAutocompleteComponent } from './components/tabs-autocomplete/tabs-autocomplete.component';
import { HeaderComponent } from './components/grid/header/header.component';
import { HeaderCellComponent } from './components/grid/header-cell/header-cell.component';
import { RowComponent } from './components/grid/row/row.component';
import { CellComponent } from './components/grid/cell/cell.component';
import { TabPanelComponent } from './components/tab-panel/tab-panel.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ImageButtonComponent } from './components/image-button/image-button.component';
import { CapitalPipe } from './pipes/capital.pipe';
import { CommonModule, DecimalPipe } from '@angular/common';
import { VolumePipe } from './pipes/volume.pipe';
import { StandingOutsharesPipe } from './pipes/standing-outshares.pipe';
import { StylePipe } from './pipes/style.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DropdownNewComponent } from './components/dropdown-new/dropdown-new.component';
import { ColorThemeSliderComponent } from './components/color-theme-slider/color-theme-slider.component';
import { HintDirective } from '@iv/shared/derictives';
import { NgForIn } from './derictives/ng-for-in.directive';
import { SymbolsAutocompleteComponent } from './components/symbols-autocomplete/symbols-autocomplete.component';
import { DxAutocompleteModule } from 'devextreme-angular/ui/autocomplete';
import { StatisticDirective } from '@iv/shared/derictives/statistic-directive';
import { StatisticService } from '@iv/shared/statistic.service';
import { PresetHeaderCellComponent } from 'app/shared/components/grid/preset-header-cell/preset-header-cell.component';
import { TuiHintModule } from '@taiga-ui/core';
import { PresetHeaderComponent } from './components/grid/preset-header/preset-header.component';
import { SimpleTableComponent } from './components/simple-table/simple-table.component';
import { TuiTableModule } from '@taiga-ui/addon-table';
import { NgDompurifySanitizer } from '@tinkoff/ng-dompurify';
import { TabComponent } from './components/tab-panel/tab/tab.component';
import { TuiCheckboxLabeledModule, TuiCheckboxModule, TuiInputModule, TuiTreeModule } from '@taiga-ui/kit';
import { ColumnsChooserTreeComponent } from './components/grid/columns-chooser-tree/columns-chooser-tree.component';
import { TuiAutoFocusModule, TuiMapperPipeModule } from '@taiga-ui/cdk';
import { ColumnsChooserSearchItemComponent } from './components/grid/columns-chooser-tree/components/columns-chooser-search-item/columns-chooser-search-item.component';
import { GroupCreationPopupContentComponent } from '@iv/shared/components/group-creation-popup-content/group-creation-popup-content.component';
import { InputTooltipComponent } from './components/input-tooltip/input-tooltip.component';
import { ConfirmationPopupContentComponent } from '@iv/shared/components/confirmation-popup-content/confirmation-popup-content.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import {
  PriceHistoricalImpliedVolatilityComponent
} from "@iv/shared/components/price-historical-implied-volatility/price-historical-implied-volatility.component";

@NgModule({
  declarations: [
    GridComponent,
    ColumnsChooserComponent,
    DropdownComponent,
    NumberInputComponent,
    TextInputComponent,
    TabsAutocompleteComponent,
    HeaderComponent,
    HeaderCellComponent,
    RowComponent,
    CellComponent,
    TabPanelComponent,
    ImageButtonComponent,
    CapitalPipe,
    VolumePipe,
    StandingOutsharesPipe,
    StylePipe,
    DropdownNewComponent,
    ColorThemeSliderComponent,
    HintDirective,
    NgForIn,
    SymbolsAutocompleteComponent,
    StatisticDirective,
    PresetHeaderCellComponent,
    PresetHeaderComponent,
    SimpleTableComponent,
    TabComponent,
    ColumnsChooserTreeComponent,
    ColumnsChooserSearchItemComponent,
    GroupCreationPopupContentComponent,
    InputTooltipComponent,
    ConfirmationPopupContentComponent,
    PriceHistoricalImpliedVolatilityComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ClipboardModule,
    DxScrollViewModule,
    ScrollingModule,
    DragDropModule,
    DxAutocompleteModule,
    TuiLoaderModule,
    TuiHintModule,
    TuiTableModule,
    TuiScrollbarModule,
    TuiSvgModule,
    TuiInputModule,
    TuiTreeModule,
    TuiMapperPipeModule,
    TuiCheckboxLabeledModule,
    TuiButtonModule,
    TuiTextfieldControllerModule,
    TuiCheckboxModule,
    TuiDialogModule,
    TuiAutoFocusModule
  ],
  exports: [
    GridComponent,
    ColumnsChooserComponent,
    DropdownComponent,
    NumberInputComponent,
    TextInputComponent,
    TabsAutocompleteComponent,
    HeaderComponent,
    HeaderCellComponent,
    ScrollingModule,
    CellComponent,
    TabPanelComponent,
    ImageButtonComponent,
    CapitalPipe,
    VolumePipe,
    StandingOutsharesPipe,
    StylePipe,
    DropdownNewComponent,
    HintDirective,
    NgForIn,
    SymbolsAutocompleteComponent,
    StatisticDirective,
    SimpleTableComponent,
    ColumnsChooserTreeComponent,
    GroupCreationPopupContentComponent,
    InputTooltipComponent,
    ConfirmationPopupContentComponent,
    FormsModule,
    ReactiveFormsModule,
    TuiButtonModule,
    TuiDialogModule,
    TuiInputModule,
    TuiTextfieldControllerModule,
    TuiAutoFocusModule,
    PriceHistoricalImpliedVolatilityComponent
  ],
  providers: [
    DecimalPipe,
    StatisticService,
    {
      provide: TUI_SANITIZER,
      useClass: NgDompurifySanitizer,
    }
  ]
})
export class SharedModule {
}
